import request from '@/utils/request'
import qs from 'qs'

// 登录
export function ApiLogin(data) {
  return request({
    url: "/connect/token",
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    data: qs.stringify(data)
  })
}

// 发送验证码
export function ApiSendCode(data) {
  return request({
    url: "/phone/SMS/SendCode",
    method: "POST",
    data
  })
}

// 用token获取用户信息
export function ApiGetInfo(params) {
  return request({
    url: "/phone/User/GetInfo",
    method: "GET",
    params
  })
}